<template>
  <div
    v-if="showModal"
    class="w-screen h-screen bg-[#00000084] z-50 fixed top-0 flex justify-center items-center"
  >
    <div
      class="flex gap-8 items-start w-[90%] lg:w-[826px] h-min min-h-[234px] p-4 bg-h-primary-200 rounded-md border-b-4 border-h-secondary-600"
    >
      <img
        src="@/assets/images/avatares/avatar-bg-white.svg"
        alt="time-modal"
      />
      <div class="mt-4 flex flex-col gap-4">
        <div class="flex justify-between">
          <h4>
            {{ title }}
          </h4>
          <MessageVoice :msg="title + '.' + content" />
        </div>
        <p>
          {{ content }}
        </p>
        <div class="flex justify-end gap-2 w-full mt-10">
          <Button
            class="btn-outline-bg-white sm:h-9 h-11"
            @click="onNeedsToPause"
          >
            {{
              $t("labels.generic", {
                pt: `Retornar ao conteúdo`,
                en: `Return to content`,
              })
            }}</Button
          >
          <Button class="btn-primary sm:h-9 h-11" @click="onOpenChat">
            {{
              $t("labels.generic", {
                pt: `Falar no chat`,
                en: `Talk in the chat`,
              })
            }}</Button
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "courseContent",
  emits: ["onOpenChat", "onNeedsToPause"],
  props: {
    nameStudent: {
      type: String,
      default: "intro",
    },
    timeLimit: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      title: this.$t("labels.generic", {
        pt: `Está tudo bem, ${this.nameStudent}?`,
        en: `Is everything okay, ${this.nameStudent}?`,
      }),
      content: this.$t("labels.generic", {
        pt: `Você ultrapassou o tempo esperado para ver esse conteúdo. Caso precise de ajuda, como tirar dúvidas sobre o conteúdo, fale comigo no chat.`,
        en: `You have exceeded the expected time to view this content. If you need assistance, such as clearing up doubts about the content, please talk to me in the chat.`,
      }),
      showModal: false as boolean,
    };
  },
  mounted() {
    if (this.timeLimit > 0) {
      this.countObjectTime();
    }
  },
  methods: {
    onOpenChat(): void {
      this.showModal = false;
      this.$emit("onOpenChat");
    },
    onNeedsToPause(): void {
      this.$emit("onNeedsToPause");
      this.showModal = false;
    },
    countObjectTime(): void {
      setTimeout(() => {
        this.showModal = true;
      }, this.timeLimit);
    },
  },
});
</script>

<style></style>
